import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';

import styles from './MainHeroMassage.module.scss';

let cx = classNames.bind(styles);

const MainHeroMassage = () => {
	const { t } = useTranslation();

	return (
		<section
			id='inicio'
			className={cx({
				main_hero: true,
				'flex flex-col w-full h-auto justify-center items-center lg:flex-row lg:justify-start lg:items-center pt-48': true,
			})}
		>
			<div className='bg-telus-purple text-white p-12'>
				<h1 className='font-HelveticaNeueLTStd-Bold text-4xl'>Welcome to <br />
					TELUS International</h1>
			</div>
		</section>
	);
};

export default MainHeroMassage;
